<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <h5>
        Subchannel Overview
      </h5>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body">
      <div class="row" v-if="rows.length">
        <div class="col-xs-16">
          <SubchannelTable :year="year" :portal="portal" :time-based-channel="timeBasedChannel" :rows="rows"/>
        </div>

        <div class="col-xs-8">
          <SubchannelChart :rows="rows" :loading="loading"/>
        </div>
      </div>

      <div v-else class="text-center text-muted" style="margin: 22px 0">
        There is no data to display!
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SubchannelChart
  from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedChannelDashboard/Panels/SubchannelOverview/SubchannelChart'
import SubchannelTable
  from '@/pages/Administration/Portals/Edit/Tabs/TimeBasedChannelDashboard/Panels/SubchannelOverview/SubchannelTable'

export default {
  components: {LoadingSpinner, SubchannelChart, SubchannelTable},

  mixins: [SaveHeight],

  props: ['year', 'portal', 'timeBasedChannel', 'targetMetric', 'user'],

  data() {
    return {
      loading: true,
      rows: []
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    targetMetric() {
      this.load()
    },

    portal() {
      this.load()
    },

    user() {
      this.load()
    }
  },

  computed: {
    filters() {
      return [
        {dimension: 'publish_year', operator: '=', value: this.year},
        {dimension: 'time_based_channel_id', operator: '=', value: this.timeBasedChannel.id}
      ]
    },

    filtersWithUser() {
      if (!this.user) {
        return this.filters
      }

      return this.filters.concat({dimension: 'user_id', operator: '=', value: this.user})
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.loading = true

      Promise.all([
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: 'time_ad_value_after_costs'},
          ],
          dimensions: [
            {name: 'time_based_subchannel_id'},
            {name: 'time_based_subchannel_name'},
            {name: 'time_based_subchannel_color'},
          ],
          filters: this.filtersWithUser
        }),
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: this.targetMetric},
          ],
          dimensions: [
            {name: 'time_based_subchannel_id'},
            {name: 'time_based_subchannel_name'},
            {name: 'time_based_subchannel_color'},
          ],
          filters: this.filters
        })
      ]).then(responses => {
        this.rows = Object.values(responses[0].data.data
            .concat(responses[1].data.data)
            .reduce((result, row) => {
              result[row.time_based_subchannel_id] = (result[row.time_based_subchannel_id] || []).concat([row])

              return result
            }, {}))
            .map((rows) => {
              let revenue = rows.reduce((result, row) => result + (row.time_ad_value_after_costs || 0), 0)

              let target = rows.reduce((result, row) => result + (row[this.targetMetric] || 0), 0)

              return {
                time_based_subchannel_id: rows[0].time_based_subchannel_id,
                time_based_subchannel_name: rows[0].time_based_subchannel_name,
                time_based_subchannel_color: rows[0].time_based_subchannel_color,
                revenue,
                target,
                index: target ? revenue / target * 100 : null,
                difference: revenue - target
              }
            })
            .filter(row => row.revenue + row.target !== 0)

        this.loading = false
      })
    }
  }
}
</script>
